import ReactMarkdown from 'react-markdown';
import { StyledDiv } from './Markdown.styles';

interface MarkdownProps {
  children: string;
  className?: string;
  linkTarget?: string;
}

function Markdown({ children, linkTarget, className }: MarkdownProps) {
  return (
    <StyledDiv className={className}>
      <ReactMarkdown
        allowedElements={['p', 'ul', 'li', 'strong', 'a', 'ol', 'img']}
        linkTarget={linkTarget}
      >
        {children}
      </ReactMarkdown>
    </StyledDiv>
  );
}

export default Markdown;
